import React from 'react';
import { Link } from "@StarberryUtils";
import './serviceCard.scss';

import { motion } from "framer-motion";

import { GetURL } from "../../../common/site/functions";
import { GetMenuTileImageURL } from "../../../common/site/menu-tile-image-path";

const contentVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4
        }
    }
}

const contentItem = {
    hidden: { opacity: 0, x: -40 },
    visible: (custom) => ({
        opacity: 1,
        x: 0,
        transition: {
            delay: custom * 0.2,
            duration: 0.6,
            ease: [0.33, 1, 0.68, 1],
        }
    })
}

const serviceCard = (props) => {

    return (
        <motion.div
            className="service-list components-Home-services-serviceCard-serviceCard"
            variants={contentVariants}
        >
            {props.Links.map((link, index) => {
                let url = GetURL(link.Select_Link.id)
                let tile_image_url = GetMenuTileImageURL(link.Select_Link.id)
                return (
                    <motion.div
                        className="list-wrap"
                        key={index}
                        custom={index + 1}
                        variants={contentItem}
                    >
                        <Link to={`/${url}`} className="list-item d-flex align-items-center">
                            <figure><img loading="lazy" src={tile_image_url} alt={`${link.Label} - Martyn Gerrard`} title="" /></figure>
                            <div className="d-flex justify-content-between align-items-center w-100"><strong>{link.Label}</strong> <span><i className="icon-longarrow-rgt"></i></span></div>
                        </Link>
                    </motion.div>
                )
            })}
        </motion.div>
    );
}

export default serviceCard;